import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class IframeService {
  // Retorna true si la aplicación está en un iframe
  isIframe(): boolean {
    return !(window !== window.parent && !window.opener);
  }
}
